import InfiniteScroll from 'react-infinite-scroll-component';
import EmptyList from '../../../assets/image/shared/empty_list.svg';
import DotsLoading from '../../../components/dotsLoading';
import React from 'react';
import MyAdItem from './item';
import {
  FetchNextPageOptions,
  InfiniteData,
  InfiniteQueryObserverResult,
} from 'react-query';

interface IShopPostProps {
  isLoading: boolean;
  hideManageInfo?: boolean;
  data: InfiniteData<IStorePosts> | undefined;
  fetchNextPage: (
    options?: FetchNextPageOptions | undefined,
  ) => Promise<InfiniteQueryObserverResult<IStorePosts, unknown>>;
}

const ShopPosts = ({
  fetchNextPage,
  hideManageInfo,
  data,
  isLoading,
}: IShopPostProps) => {
  return (
    <InfiniteScroll
      dataLength={data?.pages.flatMap(x => x?.results)?.length || 0} //This is important field to render the next data
      next={() => {
        fetchNextPage();
      }}
      style={{overflow: 'inherit'}}
      className="overflow-inherit"
      hasMore={!!data?.pages[data?.pages.length - 1].next}
      loader={
        <div className="my-3">
          <DotsLoading />
        </div>
      }
      scrollableTarget="scrollableDiv"
    >
      {isLoading ? (
        <div className="mt-4">
          <DotsLoading />
        </div>
      ) : data?.pages.flatMap(x => x.results).length === 0 ? (
        <div className="mt-4 text-center">
          <img src={EmptyList} alt="موردی برای نمایش موجود نیست" />
        </div>
      ) : (
        data &&
        React.Children.toArray(
          data?.pages.flatMap(item =>
            item?.results?.map(product => (
              <MyAdItem
                route={
                  product.status === 'published'
                    ? !hideManageInfo
                      ? `/profile/my-ads/details/${product?.guid}`
                      : ''
                    : ''
                }
                post={product}
                icon={product?.input_group ? product?.input_group?.icon : ''}
                inputGroupType={product?.input_group?.code}
                hideManageInfo={hideManageInfo}
              />
            )),
          ),
        )
      )}
    </InfiniteScroll>
  );
};

export default ShopPosts;
